<header class="header">
  <section class="header__section">
    <div class="header__top">
      <svg class="header__img--emma" viewBox="0 0 333 64" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M60.3986 27.193C60.7233 29.0602 60.9669 31.7392 60.9669 33.0381L20.7817 39.1268C23.2983 45.3778 28.3316 47.6509 34.9074 46.6767C39.3724 46.0273 43.7562 43.4294 47.0035 39.5327L60.8857 49.1122C55.69 56.0939 47.2471 61.1272 36.3687 62.6696C17.6967 65.5922 3.24631 55.0385 0.48611 36.6101C-2.43645 17.9382 8.03606 3.16306 26.0585 0.402865C43.5127 -2.27615 57.476 8.60228 60.3986 27.193ZM18.9956 27.193L40.5089 23.9457C38.0735 18.263 33.9332 15.7463 28.4128 16.4769C22.6489 17.37 19.4827 21.1855 18.9956 27.193Z" />
        <path
          d="M162.202 22.4033V61.6956H143.124V29.1415C143.124 21.9975 139.552 18.0195 133.544 18.0195C128.349 18.0195 123.884 21.5915 123.884 29.385V61.6144H104.806V29.2227C104.806 22.0786 101.234 18.1007 95.3887 18.1007C90.0306 18.1007 85.728 21.6727 85.728 29.4662V61.6956H66.4878V1.86425H84.835V9.4142C88.6505 3.08199 94.7392 0.321797 102.695 0.321797C110.57 0.321797 117.227 3.89381 120.88 10.3072C124.858 3.40671 131.677 0.321797 139.877 0.321797C153.596 0.159432 162.202 8.60237 162.202 22.4033Z" />
        <path
          d="M263.598 22.4033V61.6956H244.52V29.1415C244.52 21.9975 240.948 18.0195 234.941 18.0195C229.745 18.0195 225.28 21.5915 225.28 29.385V61.6144H206.202V29.2227C206.202 22.0786 202.63 18.1007 196.785 18.1007C191.427 18.1007 187.124 21.6727 187.124 29.4662V61.6956H168.046V1.86425H186.394V9.4142C190.209 3.08199 196.298 0.321797 204.254 0.321797C212.128 0.321797 218.785 3.89381 222.439 10.3072C226.416 3.40671 233.236 0.321797 241.435 0.321797C254.911 0.159432 263.598 8.60237 263.598 22.4033Z" />
        <path
          d="M332.927 61.6956H314.418V55.2822C310.846 59.9095 305.325 63.4004 297.207 63.4004C281.214 63.4004 269.362 49.5182 269.362 31.7393C269.362 14.2039 281.214 0.240613 297.207 0.240613C305.325 0.240613 310.765 3.65027 314.418 8.35884V1.78307H332.927V61.6956ZM288.927 31.7393C288.927 39.5328 294.041 45.5403 301.672 45.5403C309.222 45.5403 314.418 39.7763 314.418 31.7393C314.418 23.8646 309.06 17.9383 301.672 17.9383C294.041 17.9383 288.927 23.9458 288.927 31.7393Z" />
      </svg>

      <div class="flex gap-8">
        <div class="header__text">
          <p class="header__text--name"
            ><strong>{{ brokerName$ | async }}</strong></p
          >

          <div class="logout-btn" (click)="logout()">
            <i class="pi pi-sign-out logout-btn__icon"></i>
            <p class="header__text--logout" i18n>Se déconnecter</p>
          </div>
        </div>

        <div class="header__lang" (click)="languageRedirect()">
          @switch (currentLanguage) {
            @case (supportedLanguage.EN) {
              <u>FR</u>
            }
            @case (supportedLanguage.FR) {
              <u>EN</u>
            }
          }
        </div>
      </div>
    </div>

    <div class="header__button">
      @if (isStartProposalButtonDisplayed()) {
        <p-button
          (onClick)="startProposal()"
          i18n-label
          label="Débuter une demande"
          icon="pi pi-pencil"
          iconPos="left"></p-button>
      }
    </div>
  </section>

  @if (items) {
    <p-tabMenu id="headerTabMenu" class="header__menu" [model]="items" [activeItem]="items[0]"></p-tabMenu>
  }
</header>
